export default { sha: 'ed39667c5f88262b0b0cf2e83eb05930f8acc96f', buildNumber: 'undefined' }
